import React from 'react';

import {
  BACKGROUNDS_CONFIG,
  PICTURES_CONFIG,
} from '@/common/config/media-config';
import { PageBackground } from '@/components/ui/Backgrounds/PageBackground/PageBackground';
import { CloudsAnimation } from '@/components/ui/CloudsAnimation/CloudsAnimation';
import { Picture } from '@/components/ui/Picture/Picture';

const Default: React.FC = () => {
  // const { RiveComponent } = useRive({
  //   src: RIVE_CONFIG.TONY,
  //   autoplay: true,
  // });

  return (
    <PageBackground
      className="after:z-[3] h-auto w-[100%]"
      pictureClassName="relative z-[2]"
      variant="page"
      backgroundImage={{
        png: BACKGROUNDS_CONFIG.BG_OFFICE.png,
        webp: BACKGROUNDS_CONFIG.BG_OFFICE.webp,
      }}
    >
      <CloudsAnimation />
      {/* <RiveComponent className="absolute z-[3] bottom-0 left-1/2 -translate-x-1/2 aspect-[180/228] w-[12.5rem]" /> */}
      <Picture
        img={PICTURES_CONFIG.TONY.png}
        webp={PICTURES_CONFIG.TONY.webp}
        className="absolute z-[3] bottom-0 left-1/2 -translate-x-1/2 aspect-[360/576] w-[42.05%] max-w-[180px]"
        alt="default character"
      />
    </PageBackground>
  );
};

export default Default;
